<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex>
        <div class="breadcrumbs__wrapper">
          <div>
            <span class="breadcrumbs__title">Expedientes de compra</span>
          </div>
        </div>
        <v-divider class="mt-2"></v-divider>
        <!-- table EC -->
        <v-row class="mt-10">
          <v-col class="button__wrapper" cols="6">
            <v-btn
              :class="
                typeSelection === 1
                  ? 'white--text'
                  : 'white--text btn__not__selected'
              "
              @click="typeSelection = 1"
              ><v-icon left> mdi-link-variant</v-icon> EC Activos</v-btn
            ><v-btn
              :class="
                typeSelection === 2
                  ? 'white--text ml-4'
                  : 'white--text ml-4 btn__not__selected'
              "
              @click="typeSelection = 2"
              ><v-icon left> mdi-link-variant-off</v-icon> EC Cerrados</v-btn
            ><v-btn
              :class="
                typeSelection === 3
                  ? 'white--text ml-4'
                  : 'white--text ml-4 btn__not__selected'
              "
              @click="typeSelection = 3"
              ><v-icon left> mdi-link-variant-off</v-icon> TODOS</v-btn
            >
          </v-col>
        </v-row>

        <ContractsTable
          v-if="typeSelection === 1"
          class="mt-10"
          :headers="this.headersPR"
          :values="this.activeTypes"
        />
        <ContractsTable
          v-if="typeSelection === 2"
          class="mt-10"
          :headers="this.headersPR"
          :values="this.closedType"
        />
        <ContractsTable
          v-if="typeSelection === 3"
          class="mt-10"
          :headers="this.headersPR"
          :values="this.allTypes"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import Table from "@/components/Table.vue";
import ContractsTable from "@/components/contracts/ContractsTable.vue";
// import ContractsMarcoTable from "@/components/contracts/ContractsMarcoTable.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Contracts",
  components: {
    // Table,
    ContractsTable,
    // ContractsMarcoTable,
  },
  data() {
    return {
      allTypes: [],
      closedType: [],
      activeTypes: [],
      search: "",
      typeSelection: 1,
      headersPR: [
        {
          text: "Nombre de expediente",
          align: "start",
          filterable: false,
          value: "awardPropJustification.fileName",
          width: "",
        },
        { text: "Gestor", value: "promotor", width: "145px" },
        // { text: "Validador", value: "validator", width: "145px" },
        {
          text: "Importe Vigente",
          value: "awardPropJustification.amount",
          width: "",
          align: "right",
        },
        {
          text: "Grado Ejecución",
          value: "degreeOfExecution",
          align: "center",
        },
        {
          text: "% Variación del importe",
          value: "variation",
          align: "center",
        },
        {
          text: "Fecha Inicio",
          value: "resolutionPurchaseFile.fechaInicio",
          align: "center",
          width: "105px",
        },
        {
          text: "Fecha Finalización",
          value: "resolutionPurchaseFile.fechaFin",
          align: "center",
          width: "105px",
        },
        {
          text: "Estado",
          value: "contractState",
          align: "left",
          width: "125px",
        },
        { text: "Acciones", value: "actions", align: "center" },
      ],
      puntual: [],
      recurrent: [],
      marco: [],
      contractsPR: [],
      items: [
        { title: "Puntual", to: "/cecontractrandp/Puntual" },
        //{ title: "Recurrente", to: "/cecontractrandp/Recurrente" },
        { title: "Marco", to: "/cecontractmarco/Marco" },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getObjectById",
      "getContracts",
      "getUserData",
      "getCCframes",
      "getInvoices",
    ]),
    getItems() {
      if (this.getUserData) {
        if (this.getUserData.role.some((val) => [1, 2].includes(val))) {
          return this.items;
        } else {
          return this.items.filter((item) => item.title !== "Marco");
        }
      } else return [];
    },
    getDafUsers() {
      if (this.getUserData && this.getUserData.sigla === "DG") return true;
      else return false;
    },
  },
  watch: {
    getInvoices: "loadTableData", // ← Cuando cambie invoices, ejecuta loadTableData
    getContracts: "loadTableData", // ← Cuando cambie contracts, ejecuta loadTableData
    getUserData: "loadTableData", // ← Cuando cambie userData, ejecuta loadTableData
  },
  methods: {
    ...mapActions(["getDBContracts", "getDBCCframe", "getDBInvoices"]),
    loadTableData() {
      // ✅ Verificar que TODO esté listo
      if (
        !this.getInvoices ||
        !this.getContracts ||
        !this.getUserData ||
        !Array.isArray(this.getInvoices) ||
        !Array.isArray(this.getContracts)
      ) {
        return;
      }

      this.puntual = [];
      this.recurrent = [];
      this.marco = [];

      // if DG O DAF USER SEE ALL
      if (this.getDafUsers && this.getInvoices) {
        this.allTypes = this.getContracts
          .filter((item) => item !== null && item !== undefined)
          .filter(
            (item) =>
              item.awardPropJustification.fileName !==
              "Compra no sujeta al P-02"
          )
          .map((item) => {
            return {
              ...item,
              promotor: this.getPromoter(item.promoter),
              validator: this.getValidator(
                item.resolutionPurchaseFile.validator
              ),
              searchFieldsText: `
              ${item.awardPropJustification.fileName}
              ${item.modality}
              ${this.getPromoter(item.promoter)}
              ${this.getValidator(item.resolutionPurchaseFile.validator)}
              ${item.awardPropJustification.amount}
              ${item.contractState}
              ${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }
            `,
              degreeOfExecution: `${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }`,
            };
          })
          .sort((a, b) => {
            return (
              new Date(
                b.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0) -
              new Date(
                a.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0)
            );
          });

        this.closedType = this.getContracts
          .filter((item) => item !== null && item !== undefined)
          .filter((item) => item.contractState === "5-Expediente cerrado")
          .map((item) => {
            return {
              ...item,
              promotor: this.getPromoter(item.promoter),
              validator: this.getValidator(
                item.resolutionPurchaseFile.validator
              ),
              searchFieldsText: `
              ${item.awardPropJustification.fileName}
              ${this.getPromoter(item.promoter)}
              ${this.getValidator(item.resolutionPurchaseFile.validator)}
              ${item.awardPropJustification.amount}
              ${item.contractState}
              ${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }
            `,
              degreeOfExecution: `${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }`,
            };
          })
          .sort((a, b) => {
            return (
              new Date(
                b.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0) -
              new Date(
                a.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0)
            );
          });

        this.activeTypes = this.getContracts
          .filter((item) => item !== null && item !== undefined)
          .filter(
            (item) =>
              item.contractState !== "5-Expediente cerrado" &&
              item.contractState
          )
          .map((item) => {
            return {
              ...item,
              promotor: this.getPromoter(item.promoter),
              validator: this.getValidator(
                item.resolutionPurchaseFile.validator
              ),
              searchFieldsText: `
              ${item.awardPropJustification.fileName}
              ${item.modality}
              ${this.getPromoter(item.promoter)}
              ${this.getValidator(item.resolutionPurchaseFile.validator)}
              ${item.awardPropJustification.amount}
              ${item.contractState}
              ${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }
            `,
              degreeOfExecution: `${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }`,
            };
          })
          .sort((a, b) => {
            return (
              new Date(
                b.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0) -
              new Date(
                a.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0)
            );
          });
      } else if (this.getInvoices) {
        this.allTypes = this.getContracts
          .filter((item) => item !== null && item !== undefined)
          .filter(
            (item) =>
              item.awardPropJustification.fileName !==
                "Compra no sujeta al P-02" &&
              (!item.privado ||
                (item.privado === true &&
                  (this.getUserData.id === item.promoter ||
                    this.getUserData.id ===
                      item.resolutionPurchaseFile.validator)))
          )
          .map((item) => {
            return {
              ...item,
              promotor: this.getPromoter(item.promoter),
              validator: this.getValidator(
                item.resolutionPurchaseFile.validator
              ),
              searchFieldsText: `${item.awardPropJustification.fileName} ${
                item.modality
              } ${this.getPromoter(item.promoter)}
            ${this.getValidator(item.resolutionPurchaseFile.validator)}
            ${item.awardPropJustification.amount} ${item.contractState} ${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }`,
              degreeOfExecution: `${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }`,
            };
          })
          .sort((a, b) => {
            return (
              new Date(
                b.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0) -
              new Date(
                a.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0)
            );
          });

        this.closedType = this.getContracts
          .filter((item) => item !== null && item !== undefined)
          .filter(
            (item) =>
              item.contractState === "5-Expediente cerrado" &&
              item.contractState &&
              (!item.privado ||
                (item.privado === true &&
                  (this.getUserData.id === item.promoter ||
                    this.getUserData.id ===
                      item.resolutionPurchaseFile.validator)))
          )
          .map((item) => {
            return {
              ...item,
              promotor: this.getPromoter(item.promoter),
              validator: this.getValidator(
                item.resolutionPurchaseFile.validator
              ),
              searchFieldsText: `${
                item.awardPropJustification.fileName
              } ${this.getPromoter(item.promoter)}
            ${this.getValidator(item.resolutionPurchaseFile.validator)}
            ${item.awardPropJustification.amount} ${item.contractState} ${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }`,
              degreeOfExecution: `${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }`,
            };
          })
          .sort((a, b) => {
            return (
              new Date(
                b.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0) -
              new Date(
                a.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0)
            );
          });

        this.activeTypes = this.getContracts
          .filter((item) => item !== null && item !== undefined)
          .filter(
            (item) =>
              item.contractState !== "5-Expediente cerrado" &&
              item.contractState &&
              (!item.privado ||
                (item.privado === true &&
                  (this.getUserData.id === item.promoter ||
                    this.getUserData.id ===
                      item.resolutionPurchaseFile.validator)))
          )
          .map((item) => {
            return {
              ...item,
              promotor: this.getPromoter(item.promoter),
              validator: this.getValidator(
                item.resolutionPurchaseFile.validator
              ),
              searchFieldsText: `${item.awardPropJustification.fileName} ${
                item.modality
              } ${this.getPromoter(item.promoter)}
            ${this.getValidator(item.resolutionPurchaseFile.validator)}
            ${item.awardPropJustification.amount} ${item.contractState} ${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }`,
              degreeOfExecution: `${
                this.getDegreeOfExecution(item) === "NaN"
                  ? "0.00"
                  : this.getDegreeOfExecution(item)
              }`,
            };
          })
          .sort((a, b) => {
            return (
              new Date(
                b.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0) -
              new Date(
                a.creationDate.split(",")[0].split("/").reverse().join("-")
              ).setHours(0, 0, 0, 0)
            );
          });
      }
    },
    getPromoter(id) {
      let promoter = this.getObjectById("users", id);
      return promoter ? `${promoter.name} ${promoter.surname}` : "";
    },
    getValidator(id) {
      let validator = this.getObjectById("users", id);
      return validator ? `${validator.name} ${validator.surname}` : "";
    },
    getDegreeOfExecution(item) {
      if (item.typeOfPurchase === "Marco") {
        let invTotal = 0;
        // ✅ Proteger contra nulls
        if (this.getInvoices && Array.isArray(this.getInvoices)) {
          this.getInvoices
            .filter((inv) => inv !== null && inv !== undefined)
            .forEach((inv) => {
              if (inv.associatedFile === item.id) {
                invTotal += inv.taxBase;
              }
            });
        }
        let existAcceptedNewAmount = item.acceptedNewAmount
          ? item.acceptedNewAmount
          : false;
        let amount =
          existAcceptedNewAmount && item.acceptedNewAmount !== 0
            ? item.acceptedNewAmount
            : item.awardPropJustification.amount;
        return ((parseFloat(invTotal) / parseFloat(amount)) * 100).toFixed(2);
      } else {
        let existAcceptedNewAmount = item.acceptedNewAmount
          ? item.acceptedNewAmount
          : false;
        let amount =
          existAcceptedNewAmount && item.acceptedNewAmount !== 0
            ? item.acceptedNewAmount
            : item.awardPropJustification.amount;
        return (
          (1 -
            parseFloat(item.awardPropJustification.remainingProjectAmount) /
              parseFloat(amount)) *
          100
        ).toFixed(2);
      }
    },
  },
  execution(x, y) {
    return 1 - x / y;
  },
  created() {
    this.getDBInvoices();
    this.getDBContracts();
    this.getDBCCframe();
  },
};
</script>

<style scoped>
.breadcrumbs__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.breadcrumbs__title {
  padding: 8px 0;
  border-bottom: 3px solid #008076;
}

.theme--light.v-btn.v-btn--has-bg {
  background: #008076;
}

.btn__not__selected {
  background: #969696 !important;
}
.button__wrapper {
  padding: 0 12px;
}
</style>
